export const updateAllData = (tree: any, clonePhases: any, setTreeData: Function) => {
  let cloneTree = JSON.parse(JSON.stringify(tree));
  cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(clonePhases)) };
  // debugger;
  setTreeData({ treeData: cloneTree });
};
